import React, {ReactNode} from "react";

type Props = {
    children: ReactNode,
};

const OverviewSection = ({children}: Props) => {
    return (
        <section className={"min-h-0 min-w-0 flex flex-col"}>
            {children}
        </section>
    );
};

export default OverviewSection;